module.exports = __webpack_public_path__ + "static/media/world.f1af3b83.svg";